module.exports = __webpack_public_path__ + "img/przeglad-okresowy.94426ff4.jpg";